import {
  FloatingLabel,
  InputGroup,
  Form,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { Controller, Control, FieldError } from "react-hook-form";
import { NumericFormat } from "react-number-format";

type FloatNumericProps = {
  label: string;
  name: string;
  control: Control<any>;
  errorsMessage?: FieldError | undefined;
  disabled?: boolean;
  readOnly?: boolean;
  tooltipMessage?: string;
  textAlign?: "center";
  autoComplete?: boolean;
  useFloatingLabel?: boolean;
  decimalScale?: number;
};

export const FloatNumericComponent = ({
  label,
  name,
  control,
  errorsMessage,
  disabled = false,
  readOnly = false,
  tooltipMessage = "",
  textAlign,
  autoComplete = false,
  useFloatingLabel = true,
  decimalScale = 2,
}: FloatNumericProps) => {
  const inputElement = (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return (
          <NumericFormat
            value={field.value ?? undefined}
            getInputRef={field.ref}
            placeholder={label}
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={decimalScale}
            fixedDecimalScale
            allowNegative={false}
            disabled={disabled}
            readOnly={readOnly}
            inputMode="decimal"
            className={`
        form-control
        ${textAlign === "center" ? "text-center" : ""}
        ${errorsMessage?.message ? "is-invalid" : ""}
      `}
            autoComplete={autoComplete ? "on" : "off"}
            onValueChange={(values) => {
              field.onChange(values.floatValue ?? undefined);
            }}
            onBlur={field.onBlur}
          />
        );
      }}
    />
  );

  const wrappedInput = tooltipMessage ? (
    <OverlayTrigger
      placement="bottom-start"
      overlay={<Tooltip id={`tooltip-${name}`}>{tooltipMessage}</Tooltip>}
      trigger={["hover", "focus"]}
    >
      {inputElement}
    </OverlayTrigger>
  ) : (
    inputElement
  );

  return (
    <InputGroup hasValidation>
      {useFloatingLabel ? (
        <FloatingLabel label={label}>
          {wrappedInput}
          {errorsMessage?.message && (
            <Form.Control.Feedback type="invalid">
              {errorsMessage.message.toString()}
            </Form.Control.Feedback>
          )}
        </FloatingLabel>
      ) : (
        <>
          {wrappedInput}
          {errorsMessage?.message && (
            <Form.Control.Feedback type="invalid">
              {errorsMessage.message.toString()}
            </Form.Control.Feedback>
          )}
        </>
      )}
    </InputGroup>
  );
};
